exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-form-field\r\n{\r\n    padding-top:5px;\r\n    width:100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillset-add/collateralskillset-add.component.css
// module id = ../../../../../src/app/collateralskillsets/collateralskillset-add/collateralskillset-add.component.css
// module chunks = main